import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "product-remember-list" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "remember-list-buttons" }
const _hoisted_7 = { class: "messages" }
const _hoisted_8 = { class: "add-product" }
const _hoisted_9 = { class: "add-product-fields" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", null, "Legg til produkt", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Antall", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Utløpsdato", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "remember-table-wrapper"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", { class: "heading" }, "Sorter:", -1)
const _hoisted_16 = { class: "sort" }
const _hoisted_17 = { class: "sort-by" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "sort-by"
}, "Etter", -1)
const _hoisted_19 = { class: "sort-direction" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "sort-direction"
}, "Rekkefølge", -1)
const _hoisted_21 = { class: "remember-table-wrapper" }
const _hoisted_22 = { class: "mobile-remember-list" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Varenummer", -1)
const _hoisted_24 = { class: "result" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Varenavn", -1)
const _hoisted_27 = { class: "result" }
const _hoisted_28 = ["href"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Antall", -1)
const _hoisted_30 = { class: "result" }
const _hoisted_31 = { class: "remember-amount" }
const _hoisted_32 = ["value", "onBlur"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Utløpsdato", -1)
const _hoisted_34 = { class: "result" }
const _hoisted_35 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_36 = {
  key: 0,
  class: "error-text"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Kommentar", -1)
const _hoisted_38 = { class: "result" }
const _hoisted_39 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Handling", -1)
const _hoisted_41 = { class: "result remember-table__actions" }
const _hoisted_42 = {
  key: 0,
  class: "remember-table"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "mobile-none" }, "Varenummer"),
    /*#__PURE__*/_createElementVNode("th", null, "Varenavn"),
    /*#__PURE__*/_createElementVNode("th", null, "Antall"),
    /*#__PURE__*/_createElementVNode("th", null, "Utløpsdato"),
    /*#__PURE__*/_createElementVNode("th", null, "Kommentar"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_44 = { class: "mobile-none" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["href"]
const _hoisted_47 = { class: "remember-amount" }
const _hoisted_48 = ["value", "onBlur"]
const _hoisted_49 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_50 = {
  key: 0,
  class: "error-text"
}
const _hoisted_51 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_52 = { class: "remember-table__actions" }
const _hoisted_53 = { key: 2 }
const _hoisted_54 = { class: "image-modal" }
const _hoisted_55 = ["src"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "sim-modal" }
const _hoisted_58 = { class: "sim-input" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Strekkode", -1)
const _hoisted_60 = { class: "sim-actions" }
const _hoisted_61 = { class: "empty-modal" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h3", null, "Er du sikker?", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", null, "Dette vil fjerne alle produkter fra datovare-listen", -1)
const _hoisted_64 = { class: "empty-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Messages = _resolveComponent("Messages")!
  const _component_ValidationFormErrors = _resolveComponent("ValidationFormErrors")!
  const _component_ProductSelect = _resolveComponent("ProductSelect")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TextButton = _resolveComponent("TextButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          class: _normalizeClass(["tab-link", { active: _ctx.activeTab === 'datovarer' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchTab('datovarer')))
        }, " Datovarer ", 2),
        _createElementVNode("a", {
          class: _normalizeClass(["tab-link", { active: _ctx.activeTab === 'datovareuttaksliste' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchTab('datovareuttaksliste')))
        }, " Datovareuttaksliste ", 2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.activeTab === 'datovarer')
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, "Datovarer"))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'datovareuttaksliste')
          ? (_openBlock(), _createElementBlock("h1", _hoisted_5, "Datovareuttaksliste"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.developer)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.barcodeSimOpen = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Simuler scan")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.admin)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              color: "red",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emptyListOpen = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Tøm listen")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          color: "primary",
          onClick: _ctx.exportRememberList
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              class: "button-icon",
              type: "mdi",
              path: _ctx.mdiFileExport
            }, null, 8, ["path"]),
            _createTextVNode(" Eksporter til Excel ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Messages)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_ValidationFormErrors, {
          errors: _ctx.form.errors
        }, null, 8, ["errors"]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _hoisted_10,
            _createVNode(_component_ProductSelect, {
              modelValue: _ctx.form.product_id,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.product_id) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              class: "amount-field",
              type: "number",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.amount) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.amount]
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              class: "date-field",
              type: "date",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.expiryDate) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.expiryDate]
            ])
          ]),
          _createVNode(_component_Button, {
            color: "green",
            onClick: _ctx.addProduct
          }, {
            default: _withCtx(() => [
              _createTextVNode("Legg til")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      (_ctx.remembers && _ctx.remembers.filter(item => item.type === _ctx.activeTab).length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Scan produkter for å legge til. "))
        : _createCommentVNode("", true),
      (_ctx.remembers && _ctx.remembers.filter(item => item.type === _ctx.activeTab).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_Multiselect, {
                  class: "selector",
                  modelValue: _ctx.sortBy,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sortBy) = $event)),
                  canClear: false,
                  options: [
              {
                label: 'Varenummer',
                value: 'product_id',
              },
              {
                label: 'Antall',
                value: 'amount',
              },
              {
                label: 'Utløpsdato',
                value: 'expiry_date',
              },
            ]
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_Multiselect, {
                  class: "selector",
                  modelValue: _ctx.sortDirection,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sortDirection) = $event)),
                  canClear: false,
                  options: [
              {
                label: 'Stigende',
                value: 'asc',
              },
              {
                label: 'Synkende',
                value: 'desc',
              },
            ]
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_Button, {
                color: "green",
                onClick: _ctx.sortProducts
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Sorter")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rememberProducts(), (remember) => {
              return (_openBlock(), _createElementBlock("li", {
                key: remember.id
              }, [
                _hoisted_23,
                _createElementVNode("p", _hoisted_24, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.showImage(remember)),
                    class: _normalizeClass(["product-image-link", {
                  'has-image': remember.product.main_image?.url,
                }])
                  }, _toDisplayString(remember.product_id), 11, _hoisted_25)
                ]),
                _hoisted_26,
                _createElementVNode("p", _hoisted_27, [
                  _createElementVNode("a", {
                    class: "product-link",
                    href: _ctx.route('products.show', { product: remember.product_id }),
                    target: "_blank"
                  }, _toDisplayString(remember.product.name), 9, _hoisted_28)
                ]),
                _hoisted_29,
                _createElementVNode("p", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_Button, {
                      onClick: ($event: any) => (_ctx.changeAmount(remember.id, -1)),
                      color: "white",
                      size: "sm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SvgIcon, {
                          type: "mdi",
                          path: _ctx.mdiMinus
                        }, null, 8, ["path"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createElementVNode("input", {
                      type: "number",
                      value: remember.amount,
                      onBlur: ($event: any) => (_ctx.inputAmount(remember.id, remember.amount, $event)),
                      min: "0",
                      class: "amount-input"
                    }, null, 40, _hoisted_32),
                    _createVNode(_component_Button, {
                      color: "white",
                      onClick: ($event: any) => (_ctx.changeAmount(remember.id, 1)),
                      size: "sm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SvgIcon, {
                          type: "mdi",
                          path: _ctx.mdiPlus
                        }, null, 8, ["path"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _hoisted_33,
                _createElementVNode("p", _hoisted_34, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": ($event: any) => ((remember.expiry_date) = $event),
                    onBlur: ($event: any) => (_ctx.updateExpiryDate(remember.id, remember.expiry_date)),
                    class: "date-input"
                  }, null, 40, _hoisted_35), [
                    [_vModelText, remember.expiry_date]
                  ]),
                  (_ctx.expiryDateErrors[remember.id])
                    ? (_openBlock(), _createElementBlock("small", _hoisted_36, _toDisplayString(_ctx.expiryDateErrors[remember.id]), 1))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_37,
                _createElementVNode("p", _hoisted_38, [
                  _withDirectives(_createElementVNode("textarea", {
                    rows: "2",
                    "onUpdate:modelValue": ($event: any) => ((remember.comment) = $event),
                    onBlur: ($event: any) => (_ctx.updateComment(remember.id, remember.comment, $event)),
                    class: "comment-textarea"
                  }, null, 40, _hoisted_39), [
                    [_vModelText, remember.comment]
                  ])
                ]),
                _hoisted_40,
                _createElementVNode("p", _hoisted_41, [
                  _createVNode(_component_Button, {
                    onClick: ($event: any) => (
                  _ctx.removeProduct(remember.id)),
                    color: "red",
                    disabled: _ctx.removeProductLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Fjern")
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"]),
                  _createVNode(_component_Button, {
                    onClick: ($event: any) => (_ctx.moveProduct(remember.id)),
                    color: "green",
                    disabled: _ctx.moveProductLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Flytt til " + _toDisplayString(_ctx.activeTab === 'datovarer' ? 'datovareuttaksliste' : 'datovarer'), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"])
                ])
              ]))
            }), 128))
          ])
        ]),
        (_ctx.remembers && _ctx.remembers.filter(item => item.type === _ctx.activeTab).length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rememberProducts(), (remember) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: remember.id
                  }, [
                    _createElementVNode("td", _hoisted_44, [
                      _createElementVNode("p", {
                        onClick: ($event: any) => (_ctx.showImage(remember)),
                        class: _normalizeClass(["product-image-link", {
                  'has-image': remember.product.main_image?.url,
                }])
                      }, _toDisplayString(remember.product_id), 11, _hoisted_45)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        class: "product-link",
                        href: _ctx.route('products.show', { product: remember.product_id }),
                        target: "_blank"
                      }, _toDisplayString(remember.product.name), 9, _hoisted_46)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_Button, {
                          onClick: ($event: any) => (_ctx.changeAmount(remember.id, -1,)),
                          color: "white",
                          size: "sm"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_SvgIcon, {
                              type: "mdi",
                              path: _ctx.mdiMinus
                            }, null, 8, ["path"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createElementVNode("input", {
                          type: "number",
                          value: remember.amount,
                          onBlur: ($event: any) => (_ctx.inputAmount(remember.id, remember.amount, $event)),
                          min: "0",
                          class: "amount-input"
                        }, null, 40, _hoisted_48),
                        _createVNode(_component_Button, {
                          color: "white",
                          onClick: ($event: any) => (_ctx.changeAmount(remember.id, 1)),
                          size: "sm"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_SvgIcon, {
                              type: "mdi",
                              path: _ctx.mdiPlus
                            }, null, 8, ["path"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": ($event: any) => ((remember.expiry_date) = $event),
                        onBlur: ($event: any) => (_ctx.updateExpiryDate(remember.id, remember.expiry_date))
                      }, null, 40, _hoisted_49), [
                        [_vModelText, remember.expiry_date]
                      ]),
                      _createElementVNode("p", null, [
                        (_ctx.expiryDateErrors[remember.id])
                          ? (_openBlock(), _createElementBlock("small", _hoisted_50, _toDisplayString(_ctx.expiryDateErrors[remember.id]), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("textarea", {
                        rows: "3",
                        cols: "35",
                        "onUpdate:modelValue": ($event: any) => ((remember.comment) = $event),
                        onBlur: ($event: any) => (_ctx.updateComment(remember.id, remember.comment, $event))
                      }, null, 40, _hoisted_51), [
                        [_vModelText, remember.comment]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_Button, {
                          onClick: ($event: any) => (_ctx.removeProduct(remember.id)),
                          color: "red",
                          disabled: _ctx.removeProductLoading
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Fjern")
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"]),
                        _createVNode(_component_Button, {
                          onClick: ($event: any) => (_ctx.moveProduct(remember.id)),
                          color: "green",
                          disabled: _ctx.moveProductLoading
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Flytt til " + _toDisplayString(_ctx.activeTab === 'datovarer' ? 'datovareuttaksliste' : 'datovarer'), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.remembers || _ctx.remembers.filter(item => item.type === _ctx.activeTab).length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_53, " Ingen produkter i datovare-listen. Scan produkter for å legge til. "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showProductImageModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          "with-card": true,
          onDismiss: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showProductImageModal = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_component_TextButton, {
                class: "image-modal__close",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showProductImageModal = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SvgIcon, {
                    type: "mdi",
                    path: _ctx.closeIcon
                  }, null, 8, ["path"])
                ]),
                _: 1
              }),
              (_ctx.currentProduct?.main_image?.url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "image-modal__image",
                    src: _ctx.currentProduct?.main_image?.url,
                    alt: "Produktbilde"
                  }, null, 8, _hoisted_55))
                : (_openBlock(), _createElementBlock("p", _hoisted_56, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.currentProduct?.name), 1),
                    _createTextVNode(" har ingen bilde. ")
                  ]))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.barcodeSimOpen)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          class: "bg-opacity-20"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.barcodeSim) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.barcodeSim]
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_component_Button, {
                  color: "gray",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.barcodeSimOpen = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lukk")
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  color: "green",
                  onClick: _ctx.simScan
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Scan")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.emptyListOpen)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 2 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _hoisted_63,
              _createElementVNode("div", _hoisted_64, [
                _createVNode(_component_Button, {
                  color: "red",
                  onClick: _ctx.emptyList,
                  disabled: _ctx.emptyListLoading
                }, {
                  default: _withCtx(() => [
                    (_ctx.emptyListLoading)
                      ? (_openBlock(), _createBlock(_component_SvgIcon, {
                          key: 0,
                          class: "loading animate-spin",
                          type: "mdi",
                          path: _ctx.mdiLoading
                        }, null, 8, ["path"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" Fjern alle produkter ")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_Button, {
                  color: "gray",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.emptyListOpen = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Avbryt")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}